<template>
  <div class="page-container">
    <!-- 右側懸浮選單2 -->
    <div    
    :class="['floating-menu-container', !isPC ? 'floating-menu-container-mobile' : '' ]"
    :style="{ top: position.y + 'px', left: position.x + 'px' }"
    @mousedown="startDrag" >
  
    <!-- 收合/展開按鈕 (可拖動) -->
    <button @click="toggleMenu" class="menu-toggle"  >
      <el-icon :size="24">
        <component :is="!isMenuCollapsed ? Close : Menu" />
      </el-icon>
    </button>

    <!-- 懸浮選單 (展開時顯示) -->
    <transition name="fade">
      <div v-if="!isMenuCollapsed" :class="['floating-menu', !isPC ? 'floating-menu-mobile' : '' ]">
        <ul class="menu-list">
          <li v-for="(section, index) in sections" :key="index">
            <el-icon v-show="section.title === '活動報名'"><House /></el-icon>
            <el-icon v-show="section.title === '活動理念'"><HelpFilled /></el-icon>
            <el-icon v-show="section.title === '診斷分析'"><Histogram /></el-icon>
            <el-icon v-show="section.title === '經典回顧'"><Picture /></el-icon>
            <el-icon v-show="section.title === '計畫依據'"><DataLine /></el-icon>
            <el-icon v-show="section.title === '活動目的'"><Flag /></el-icon>
            <el-icon v-show="section.title === '活動說明'"><Notebook /></el-icon>
            <a @click="scrollToSection(section.id)">{{ section.title }}</a>
          </li>
        </ul>

        <!-- 回到頂部 -->
        <div class="top-button">
          <el-button @click="scrollToTop">
            <el-icon><ArrowUp /></el-icon>
          </el-button>
        </div>
      </div>
    </transition>
  </div>         
    <!-- 主視覺 -->
    <section  class="section section-1 main-visual">
      <img src="../../assets/img/goodkid/goodkid_BANNER_1920.png" alt="" class="hero-img" />
    </section>
    <!-- 分隔線 -->
    <div class="divider-d">
      <img src="../../assets/img/bean/bean_02_2.png" width="50px" alt="" class="logo-img" />
    </div>
  
     <!-- 活動報名 -->
     <section id="section1" class="section section-1">
      <div class="content">
        <h1>好小子活動報名
          <a @click="scrollToSection('section5')">
            <span style=" font-size: 1.2rem; color: #2d8cf0; margin-left: 10px; vertical-align: middle;" :class="[isPC ? '' : 'span-mobile']">
              詳細資訊請參考活動說明
              <el-icon><CaretBottom /></el-icon>
            </span>
          </a>
        </h1>
        <p class="text-spacing" style="font-weight: 600;color: #D68C45;font-size: 1.3rem;">
          2026年度 全國閱讀好小子學藝競賽活動<br/>                 
        </p>
         <el-button size="large" class="goScheduleButton" @click="openNewWindow('https://go.habook.tw/8syd22')"  round>
            領航教師LINE社群
          </el-button>
         <el-button size="large" class="goScheduleButton" @click="openNewWindow('https://drive.google.com/drive/folders/1BX0pAgWRtx04oZ3dchYw0OJ9lbpvfYiW?usp=sharing')"  round>
            文本與活動資訊
          </el-button>
           <br/> <br/> 
        <p class="text-spacing">
          📅 正式報名期間：8/31 - 9/30 <el-button size="large" class="goSignupButton" @click="goPage('/goodkid2026')" round>前往</el-button><br/>
          🎁 報名即贈 HiTeach Web IRS 50 人版 4 個月授權！
          <!-- <br/><br/>            
          🔹 早鳥報名：3/20 - 5/31<br/> 
          📢 早鳥報名期間再加碼抽 3個月授權模組（智慧評分 / 協作 / AI GPT）！<br/>
          📌 每報名 10 班，即抽出 1 位老師獲得獎勵（輪流抽出三項模組），模組將透過優惠券發放。 
          <a target="_blank" href="https://www.facebook.com/share/p/1CbPkPC68Y/" class="lottery-announcement-btn">
             抽獎結果公告 
          </a> -->
          <br/><br/>
          📖 全國閱讀好小子活動 📚 研習場次資訊 
           <el-button size="large" class="goScheduleButton" @click="openNewWindow('https://www.habook.com/zh-tw/event.php?act=view&id=208')"  round>
            查看場次
           </el-button>
          <br/>           
          <!-- 💡 注意事項：<br/>
          📍 抽獎每月舉行一次，當月報名者當月參與，且不重複中獎。<br/>
          📍 如老師遇到不確定「新學期所教班級」之狀況，本次活動在報名時，透過簡易名單，可先填寫預計參加的班級、預估人數，做預報名。 待後續班級名單確認後，再來重新匯入、編輯學生名單皆是可以的，請師長們放心報名參加！ 
         -->
        </p>
         
      </div>
    </section>

    <!-- 分隔線 -->
    <div class="divider-d">
      <img src="../../assets/img/bean/bean_02_2.png" width="50px" alt="" class="logo-img" />
    </div>
  
     <!-- 活動理念 -->
     <section id="section2" class="section section-1">
      <div class="content">
        <h1>好小子活動理念</h1>
        <p class="text-spacing" style="font-weight: 600;color: #D68C45;font-size: 1.3rem;">
          為什麼在 AI 內容爆炸的時代<br/>
          我們更需要閱讀素養檢測？
        </p>
        <p class="text-spacing">
          在這個世代，孩子每天接觸的資訊，比任何一個時代都多。AI 能快速產生文字、圖像與數據，但「理解、判斷與選擇」，仍然必須由人來完成。<br/><br/>
          因此，在 108 課綱強調素養導向的教學現場，「會不會讀」已經不只是認字或讀完文章，而是包含了——能不能看懂圖像、能不能讀懂表格、能不能理解一句話背後的深意、以及能不能在混合資訊中做出合理判斷。
        </p>
        <p class="text-spacing" style="font-weight: 600;color: #D68C45;font-size: 1.3rem;">
          我們測的是「現況」，不是「排名」
        </p>
        <p class="text-spacing">
          本競賽由陳欣希教授與小貓頭鷹閱讀理解專家團隊精心設計題目，參照 
          <a class="a_color" href="https://cirn.moe.edu.tw/WebContent/index.aspx?sid=1199&mid=14127" target="_blank">PISA</a>、
          <a class="a_color" href="https://cirn.moe.edu.tw/Module/index.aspx?sid=1201" target="_blank">PIRLS</a>
           國際評量標準，針對國小低年級至國中不同學習階段，設計出涵蓋五大核心文類的素養題型，並透過HiTeach課堂教學軟體，師生感受科技融入教學的效益，更快速有效的實施課堂測驗，幫助生生用平板的智慧評量，老師與學生可以獲得診斷報告，提升閱讀素養！
        </p>
      </div>
    </section>

    <!-- 分隔線 -->
    <div class="divider-d">
      <img src="../../assets/img/bean/bean_02_2.png" width="50px" alt="" class="logo-img" />
    </div>
  
     <!-- 計畫依據 -->
     <section id="section3" class="section section-1">
      <div class="content">
        <h1>好小子計畫依據
          <span style="font-size: xx-large;">
            <!-- 計畫簡章 -->
            <a href="https://drive.google.com/drive/folders/1BX0pAgWRtx04oZ3dchYw0OJ9lbpvfYiW?usp=sharing" target="_blank"><el-icon><Folder /></el-icon></a>
          </span>
          </h1>
        <p class="text-spacing">依據教育部「推動中小學數位學習精進方案」，以提升教師數位教學及學生運用數位學習平臺、工具與資源的能力，達成「班班有網路 生生用平板」教育政策目標。
          </p>
      </div>
    </section>

    <!-- 分隔線 -->
    <div class="divider-d">
      <img src="../../assets/img/bean/bean_02_2.png" width="50px" alt="" class="logo-img" />
    </div>
  
     <!-- 活動目的 -->
     <section id="section4" class="section section-1">
      <div class="content">
        <h1>好小子活動目的</h1>
        <div class="text-spacing">
          <ul class="list-spacing">
            <li>一、透過多元的閱讀素養評量，提升各學習階段學生的學習動力與能力。</li>
            <li>二、建立三階段閱讀素養競賽模式，提升學生學習動機與參與度。</li>
            <li>三、運用科技輔助學習，培養親師生的數位素養與科技應用能力。</li>
            <li>四、提供實用且豐富的閱讀資源，支援教師與學生的循序學習與探究需求。</li>
          </ul>          
        </div>
      </div>
    </section>
     <!-- 分隔線 -->
    <div class="divider-d">
      <img src="../../assets/img/bean/bean_02_2.png" width="50px" alt="" class="logo-img" />
    </div>
  
     <!-- 好小子活動組別與獎品 -->
     <section id="section4" class="section section-1">
      <div class="content">
        <h1>好小子活動組別與獎品</h1>
        <div class="text-spacing">
          <ul class="list-spacing">
            <li>活動組別</li>
            <li>國小低年級組</li>
            <li>國小中年級組</li>
            <li>國小高年級組</li>
            <li>國中組</li>
            <li>國中組、國小高年級組、國小中年級組、國小低年級組分別獎勵：</li>
            <li>班級獎(班級閱讀決賽)</li>
            <li>一、第一名：取 1 名，各頒發獎狀 1 張，以及價值一萬元的圖書。</li>
            <li>二、第二名：取 1 名，各頒發獎狀 1 張，以及價值六千元的圖書。</li>
            <li>三、第三名：取 1 名，各頒發獎狀 1 張，以及價值四千元的圖書。</li>
            <li>四、優秀獎：取 6 名，各頒發獎狀 1 張，以及價值二千元的圖書。</li>
            <li>五、入圍獎：取 9 名，各頒發獎狀 1 張，以及價值一千元的圖書。</li>
            <li>個人獎(班級代表挑戰賽)</li>
            <li>個人挑戰賽各組取前 10 名，每一名頒贈獎狀 1 張，獎品 1 份。</li>
          </ul>          
        </div>
      </div>
    </section>   
   

    <!-- 分隔線 -->
    <div class="divider-d">
      <img src="../../assets/img/bean/bean_02_2.png" width="50px" alt="" class="logo-img" />
    </div>
  
     <!-- 活動目的 -->
     <section id="section5" class="section section-1">
      <div class="content">
        <h1>好小子活動說明</h1>
        <div class="text-spacing">
          <ul class="list-spacing">
            <li><a href="https://www.habook.com/zh-tw/faq.php?act=view&id=263#download" target="_blank">一、HiTeach軟體安裝與基本操作</a></li>
            <li><a href="https://www.habook.com/zh-tw/faq.php?act=view&id=263#join" target="_blank">二、建立名單與官網班級報名畫面</a></li>
            <li><a href="https://www.habook.com/zh-tw/faq.php?act=view&id=263#summer" target="_blank">三、學生暑期自主閱讀資源(含習作)</a></li>
            <li><a href="https://www.habook.com/zh-tw/faq.php?act=view&id=263#practice" target="_blank">四、班級熱身賽操作流程</a></li>
            <li><a href="https://www.habook.com/zh-tw/faq.php?act=view&id=263#finals" target="_blank">五、班級決賽操作流程</a></li>
            <li><a href="https://www.habook.com/zh-tw/faq.php?act=view&id=263#contest" target="_blank">六、班級代表挑戰賽操作流程</a></li>
            <li><a href="https://www.habook.com/zh-tw/faq.php?act=view&id=263#clouDAS" target="_blank">七、HiTeach評量結果診斷報告之解讀與分析</a></li>
            <li><a href="https://www.habook.com/zh-tw/faq.php?act=view&id=263#Introduction" target="_blank">八、活動說帖</a></li>
            <li>九、名師邀你一起參與</li>
            <div class="video-container">
              <div v-for="(video, index) in videos" :key="index" class="video-item">
                <iframe :src="video.url" title="YouTube video" frameborder="0" allowfullscreen class="video-caption"></iframe>
                <p class="video-description"><span v-html="video.description"></span></p>
              </div>
            </div>
           
          </ul>          
        </div>
      </div>
    </section>   
  
    <!-- 分隔線 -->
    <div class="divider-d">
      <img src="../../assets/img/bean/bean_02_2.png" width="50px" alt="" class="logo-img" />
    </div>
  
    <!-- 診斷分析報告 -->
    <section id="section6" class="section section-3">
      <div class="content">
        <h1>好小子診斷分析報告</h1>
        <p class="text-spacing">活動過程精彩刺激，報名參賽的班級，老師還可以看到全班學生的評量結果診斷分析、試題分析，學生也能夠自主查閱個人報告，檢視自己的學習分析報告。
          <ul class="list-spacing">
            <li>一、學生個人報告：學習診斷分析</li>
            <li>二、教師班級報告：全班診斷分析</li>
            <li>三、試題分析報告：班級試題診斷分析</li>
          </ul>         
          </p>
        <el-carousel :interval="3000" arrow="always" :indicator-position="isPC ? 'outside' : 'none'" type="card" :autoplay="true"
          :height="isPC ? '500px' : '150px'" class="carousel-container">
          <div class="carousel-item">
            <el-carousel-item v-for="(image, index) in imageListSection3" :key="index">
              <img :src="image" :class="['carousel-img-analysis', isPC ? 'carousel-img-isPC' : 'carousel-img-isMobile' ]" />
            </el-carousel-item>
          </div>
        </el-carousel>        
      </div>
    </section>

     <!-- 分隔線 -->
     <div class="divider-d">
      <img src="../../assets/img/bean/bean_02_2.png" width="50px" alt="" class="logo-img" />
    </div>
  
    <!-- 經典活動回顧 -->
    <section id="section7" class="section section-2">
      <div class="content">
        <h1>好小子經典活動回顧</h1>
        <p class="text-spacing">好小子活動是歷史悠久的團隊學藝競賽，以班級為單位，跨班級、跨區域的數位學習競賽活動。2002年起，
          由台北市政府教育局與醍摩豆研發團隊共同舉辦「台北英語好小子學藝競賽」，包含網路自主學習與全班IRS互動競賽的數位學習活動，
          並由社會團體及內容供應商公益贊助這項活動的學習資源，包括臺灣讀寫教學研究學會、財團法人語言訓練測驗中心(LTTC)、佳音英語、翰林出版事業等提供免費公益學習教材與試題。
          從2002至2016年止，這項「好小子學藝競賽」活動連續舉辦了十五屆，是數位學習年度盛事，每一年都有數以萬計的學生參與這項資源豐沛「以競賽促進學習」的學習活動，
          參賽班級從熱身賽到決賽，再到緊張刺激的個人挑戰賽，整個競賽過程充滿學習能量，參賽者積極投入學習，是班級學生期待的、最愛的年度學習競賽活動。
          </p>
        <el-carousel :interval="3000" arrow="always" :indicator-position="isPC ? 'outside' : 'none'" type="card" :autoplay="true"
          :height="isPC ? '500px' : '150px'"  >
          <div class="carousel-item">
            <el-carousel-item v-for="(image, index) in imageListSection2" :key="index">
              <img :src="image"  :class="['carousel-img-review', isPC ? 'carousel-img-isPC-review' : 'carousel-img-isMobile-review' ]" />
            </el-carousel-item>
          </div>
        </el-carousel>
        <p class="text-spacing">「2024全國閱讀好小子學藝競賽」，活動成果豐碩，22個縣市400多個班級，超過1萬名學生報名參加競賽，結合超過10家出版社的文本授權，
          響應108課綱與生生用平板政策，試題參照
          <a class="a_color" href="https://cirn.moe.edu.tw/WebContent/index.aspx?sid=1199&mid=14127" target="_blank">PISA</a>、
          <a class="a_color" href="https://cirn.moe.edu.tw/Module/index.aspx?sid=1201" target="_blank">PIRLS</a>
            等級，延請閱讀理解專家設計多元有趣的閱讀素養題型，並透過HiTeach軟體自動化的競賽系統，讓師生感受科技融入教學的效益，
          老師和學生可查閱學習診斷分析報告，精準掌握學習能力與狀態。</p>
        
          <h1>好小子回顧影片</h1>
        <div class="video-container">
          <div v-for="(video, index) in reviewVideos" :key="index" class="video-item">
            <iframe :src="video.url" title="YouTube video" frameborder="0" allowfullscreen class="video-caption"></iframe>
            <p class="video-description"><span v-html="video.description"></span></p>
          </div>
        </div>
  
      </div>
    </section>

    <!-- 分隔線 -->
    <div class="divider-d">
      <img src="../../assets/img/bean/bean_02_2.png" width="50px" alt="" class="logo-img" />
    </div> 
   
    <section id="section8" class="section section-4">
  <div class="content">
    <h1>好小子歷屆活動成果</h1>
    <!-- <p>歷屆活動的詳細資訊</p> -->

    <!-- 桌機版表格 -->
    <div class="table-container gray-theme" v-if="isPC">
      <el-table
      class="custom-table"
        :data="ActivityData"
        style="width: 70%; max-width: 100%; margin: auto"
        :row-style="{ height: '70px' }"
        :header-cell-style="{ fontSize: '18px', fontWeight: 'bold' }"
        :cell-style="{ fontSize: '16px' }"
      >
        <el-table-column prop="startTime" label="時間" >
          <template #default="scope">
            <div>{{ scope.row.startTime }} ~ {{ scope.row.endTime }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="stepName" label="名稱" :width="600">
          <template #default="scope">
            <div class="otheBlueColor cursorPointer" @click="goPage(scope.row.pathname)">
              {{ scope.row.stepName }}
            </div>            
          </template>
        </el-table-column>
        <el-table-column prop="location" label="地點" :width="200">
          <template #default="scope">
            <div class="info-cell" v-html="scope.row.location"></div>
          </template>
        </el-table-column>        
      </el-table>
    </div>

    <!-- 手機版塊狀顯示 -->
    <div class="mobile-card-container" v-else>
      <div class="mobile-card" v-for="(activity, index) in ActivityData" :key="index">
        <div class="mobile-card-section">
          <strong>時間：</strong>{{ activity.startTime }} ~ {{ activity.endTime }}
        </div>
        <div class="mobile-card-section">
          <strong>名稱：</strong>
          <span class="otheBlueColor cursorPointer" v-if="activity.pathname !== '/goodkid2025'" @click="goPage(activity.pathname)">
            {{ activity.stepName }}
          </span>
          <span class="otheBlueColor cursorPointer" v-else  >
            {{ activity.stepName }}
          </span>
        </div>
        <div class="mobile-card-section">
          <strong>地點：</strong>
          <span v-html="activity.location"></span>
        </div>       
      </div>
    </div>
  </div>
</section>

    <section id="section9" class="section section-5">
      <div class="content">       
        <p :class="[ isPC ? 'foot' : 'foot-isMobile']">
            指導單位： 教育部國民及學前教育署<br/>
            主辦單位： 高雄市政府教育局、臺灣科技領導與教學科技發展協會、臺灣讀寫教學研究學會、小貓頭鷹智慧聯盟校<br/>
            協辦單位： 臺北市政府教育局、新竹縣政府教育局、臺中市政府教育局、南投縣政府教育處、屏東縣政府教育處、全球醍摩豆智慧教育研究院、臺北市南天扶輪社 (依單位及縣市順序排序,各縣市陸續邀請中)<br/>
            合作單位： 小魯文化、大穎文化、中華教育創新發展學會、水滴文化、東方出版社、均仕邦、國語日報社、奧林文化、維京文化、臺灣麥克、趣·讀冊、METAMatch 生態圈媒合平台(依筆畫順序排序)<br/>
       </p>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onUnmounted } from "vue";
import { Menu, Close, ArrowUp, House, HelpFilled, Histogram, Picture, DataLine, Flag } from "@element-plus/icons-vue";


let isPC = ref(true);//判斷是否是PC


const videos = [  
  { url: "https://www.youtube.com/embed/zBgSXiJ1yw4", description: "2025全國閱讀好小子 預告片 即將開跑！<br/> 一分鐘精彩預告片，參與活動的好處重點快速掌握！" },
  { url: "https://www.youtube.com/embed/1IIvBMY-X5A", description: "南投縣三光國中：蕭秀緞老師<br/>多元評量專題工作坊，參與好小子活動名師現身說法，告訴你數據診斷、精準教學策略！" },
  { url: "https://www.youtube.com/embed/pxhFnaBXvU8", description: "屏東縣屏東市仁愛國小：黃偉菖老師<br/>以漫畫卡通對話方式說明活動特色，生動有又有趣！" },
  { url: "https://www.youtube.com/embed/5krBQYIKelc", description: "新竹縣政府教育局： 商借教師 蔡依蘭<br/>3分鐘整體活動參與流程說明~清楚了解活動進程安排。" },
  // { url: "https://www.youtube.com/embed/WWWWWW", description: "影片 4 說明" },
];

const reviewVideos = [
  { url: "https://www.youtube.com/embed/e20i3qrBnJY", description: "2024全國閱讀好小子：HiTeach科技化評量提升閱讀素養 挑戰賽&頒獎回顧" },
  { url: "https://www.youtube.com/embed/inKmDvXvPLo", description: "2025全國閱讀好小子回顧：HiTeach閱讀挑戰賽：發揚合作共學、普特共融" }
];

//活動資訊資料
  let ActivityData = reactive([
    {
      startTime: "2025-06-09", endTime: "2025-09-27", stepName: "2025年度 全國閱讀好小子學藝競賽活動", location: "全國", pathname: "/goodkid2025"
    },
    {
      startTime: "2024-09-09", endTime: "2024-11-09", stepName: "2024年度 全國閱讀好小子學藝競賽活動", location: "全國", pathname: "/goodkid2024"
    }
  ])
     
// 是否收合懸浮選單
const isMenuCollapsed = ref(true);

// 選單對應區塊
const sections = ref([
  { id: "section1", title: "活動報名" },
  { id: "section2", title: "活動理念" },
  { id: "section3", title: "計畫依據" },
  { id: "section4", title: "活動目的" },
  { id: "section5", title: "活動說明" },
  { id: "section6", title: "診斷分析" },
  { id: "section7", title: "經典回顧" },
]);

// 跑馬燈圖片
const imageListSection2 = [
  require("@/assets/img/goodkid/2014第十三屆台北英語好小子競賽.jpg"),
  require("@/assets/img/goodkid/2015第十四屆台北英語好小子競賽.jpg"),
  require("@/assets/img/goodkid/2024輪播1.jpg"),
  require("@/assets/img/goodkid/2024輪播2.jpg"),
  require("@/assets/img/goodkid/DSC00658.jpg"),
  require("@/assets/img/goodkid/DSC00687.jpg"),
  require("@/assets/img/goodkid/DSC00702.jpg"),
  require("@/assets/img/goodkid/DSC00740.jpg"),
  require("@/assets/img/goodkid/DSC00744.jpg"),
  require("@/assets/img/goodkid/IMG_2989.jpg"),
  require("@/assets/img/goodkid/LINE_ALBUM_2024前金國小高年級全國閱讀好小子_241029_5.jpg"),
  require("@/assets/img/goodkid/LINE_ALBUM_2024前金國小高年級全國閱讀好小子_241029_31.jpg"),
  require("@/assets/img/goodkid/p1.jpg"),
  require("@/assets/img/goodkid/p2.jpg"),
  require("@/assets/img/goodkid/p3.jpg"),
  require("@/assets/img/goodkid/p4.jpg"),
  require("@/assets/img/goodkid/p6.jpg"),
  require("@/assets/img/goodkid/S__65003564_0.jpg"),
  require("@/assets/img/goodkid/台南大成國小4.jpg"),
  require("@/assets/img/goodkid/閱讀好小子競賽練習賽.jpg")
];
const imageListSection3 = [
  require("@/assets/img/goodkid/clouDAS_report_S.png"),
  require("@/assets/img/goodkid/clouDAS_report_T.png"),
  require("@/assets/img/goodkid/clouDAS_student.png"),
  require("@/assets/img/goodkid/clouDAS_teacher.png")
];

const position = ref({ x: window.innerWidth - 220, y: 100 }) // 預設在右上角
let isDragging = false
let offset = { x: 0, y: 0 }
// 滑鼠按下開始拖動
const startDrag = (event) => {
  isDragging = true
  offset = {
    x: event.clientX - position.value.x,
    y: event.clientY - position.value.y
  }
  document.addEventListener('mousemove', dragMenu)
  document.addEventListener('mouseup', stopDrag)
}
// 拖動過程中移動選單
const dragMenu = (event) => {
  if (isDragging) {
    let newX = event.clientX - offset.x
    let newY = event.clientY - offset.y

    // 限制範圍，避免拖出視窗外
    newX = Math.max(0, Math.min(window.innerWidth - 60, newX))
    newY = Math.max(0, Math.min(window.innerHeight - 60, newY))

    position.value = { x: newX, y: newY }
  }
}

// 停止拖動
const stopDrag = () => {
  isDragging = false
  document.removeEventListener('mousemove', dragMenu)
  document.removeEventListener('mouseup', stopDrag)
}

// 切換選單狀態
const toggleMenu = () => {
  isMenuCollapsed.value = !isMenuCollapsed.value;
};

// 滾動到指定區塊
const scrollToSection = (id) => {
  const section = document.getElementById(id);
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
};
// 🔹 回到頂部
const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};
function goPage(pathname) {
  location.href = location.origin + pathname  
}
//抓資料看是否是手機
function isMobileBrowser(){
  isPC.value =  window.innerWidth >= 768;
  //isPC.value =  sessionStorage.getItem("isPC") === 'true';
}
onMounted(async () => {
  isMobileBrowser()
  window.addEventListener('resize', isMobileBrowser)
  // 確保視窗大小變化時，選單仍在視野內
   window.addEventListener('resize', () => {
    position.value.x = Math.min(position.value.x, window.innerWidth - 60)
    position.value.y = Math.min(position.value.y, window.innerHeight - 60)
  })
})
onUnmounted(() => {
  window.removeEventListener('resize', isMobileBrowser);
})
function openNewWindow(url) {
  window.open(url, '_blank');
}

</script>

<style scoped>
.goScheduleButton {
  font-size: large;
  background: linear-gradient(135deg, #5aa7da 0%, #3f8fc7 100%) !important;  
  color: white !important;  
  box-shadow: 0 4px 12px rgba(63, 143, 199, 0.35);
}

.goScheduleButton:hover {
  font-size: large;
  background: linear-gradient(135deg, #4a9fd6 0%, #2f83be 100%) !important;
}
.goSignupButton {
  font-size: large;
  background: linear-gradient(135deg, #F59F56 0%, #E88847 100%) !important;
  border: none;
  color: white !important;  
}

.goSignupButton:hover {
  font-size: large;
  background: linear-gradient(135deg, #E88847 0%, #F59F56 100%) !important;  
}
.a_color{
  color:#2d8cf0;
}

/* 抽獎結果公告按鈕樣式 */
.lottery-announcement-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 50%, #ff6b6b 100%);
  color: white !important;
  padding: 0 16px;
  height: 40px;
  border-radius: 25px;
  text-decoration: none;
  font-weight: bold;
  font-size: large;
  margin-left: 8px;
  margin-right: 8px;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
  transition: all 0.3s ease;
  /* border: 2px solid #fff; */
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  line-height: 1;
}

.lottery-announcement-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4);
  background: linear-gradient(135deg, #ff5252 0%, #ff7979 50%, #ff5252 100%);
  color: white !important;
}

.lottery-announcement-btn:before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.lottery-announcement-btn:hover:before {
  left: 100%;
}

/* 手機版樣式調整 */
@media (max-width: 768px) {
  .lottery-announcement-btn {
    font-size: large;
    padding: 0 12px;
    height: 40px;
    margin-left: 4px;
    margin-right: 4px;
  }
}

.span-mobile {
  display: block;
}
/*video=============================================================================*/
.video-container {
  display: grid;
  grid-template-columns: repeat(1, 1fr); /* 預設手機版 1 列 */
  gap: 20px;
  justify-content: center;
  padding: 20px;  
}

.video-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.video-caption {
  width: 100%;
  height: 455px;
  border-radius: 10px;
}

.video-description {
  margin-top: 10px;
  font-size: 1rem;
  color: #333;
}
@media (min-width: 768px) {
  .video-container {
    grid-template-columns: repeat(2, 1fr);
  }
}
/*video end=============================================================================*/
.link-icon{
  font-size: 2em;
}
/* 桌機版表格保持原本樣式 */
.table-container {
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 10px;
}

/* 手機版塊狀卡片樣式 */
.mobile-card-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 10px;
}

.mobile-card {
  background: #f8f9fa;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
}

.mobile-card-section {
  margin-bottom: 10px;
  font-size: 16px;
  color: #333;
}

.mobile-card-section strong {
  font-weight: bold;
  color: #2c3e50;
}

/* 針對小螢幕隱藏桌機版表格，顯示塊狀 */
@media (max-width: 768px) {
  .table-container {
    display: none;
  }

  .mobile-card-container {
    display: flex;
  }
  .video-caption {
  width: 100%;
  height: 300px;
  border-radius: 10px;
  }
}

/* 針對桌機版隱藏手機版塊狀 */
@media (min-width: 769px) {
  .mobile-card-container {
    display: none;
  }
}

  .main-visual{
    margin-top: -40px;
  }
  .text-spacing {
    font-size: 1.1rem;    
    line-height: 1.8; /* 增加行距 */
    margin-bottom: 15px; /* 增加段落間距 */
}

.list-spacing {
    padding-left: 20px; /* 讓列表保持縮進 */
    margin-top: 10px;    
}

.list-spacing li {
    line-height: 1.8; /* 列表的行距 */
    margin-bottom: 8px; /* 增加列表項之間的間距 */
}
.list-spacing a {
    color: #2d8cf0;    
}


  .cursorPointer {
    cursor: pointer;
  }

  .divider-d {
    width: 96%;
    height: 2px;
    margin-top: 50px;
    margin-left: 2%;
    margin-right: 2%;
    background: #b4b4b4;
    display: flex;
    align-items: center;
    /* 讓圖片 & <hr> 水平對齊 */
    gap: 20px;
    /* 圖片 & 線條的間距 */

  }

  .logo-img {
    background: #F5F7FA;
  }

  .divider {
    width: 80%;
    border: none;
    background-color: #b4b4b4;
    /* 分隔線顏色 */

  }

  .hero-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* 讓圖片等比例填滿 */
  }

  /* 整體頁面設計 */
  .page-container {
    font-family: "Noto Sans", sans-serif;
    background: #F5F7FA;
    /* 柔和背景灰 */
  }

  /* 頂部 LOGO 區 */
  .header {
    background: #A4B3C4;
    /* 柔和灰藍 */
    padding: 20px;
    display: flex;
    justify-content: center;
  }

  .logo {
    height: 60px;
  }

  /* 四個區塊的基本樣式 */

  .section {
    display: flex;
    align-items: center;
    justify-content: center;

  }

  /* 讓內容靠左並留白 */
  .content {
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
  }

  /* 各區塊的不同背景色 */
  .section-1 {
    /*background: #F5F7FA;   柔和背景灰 */
    color: #4F6271;
  }

  .section-2 {
    background: #F5F7FA;
    /* 柔和背景灰 */
    color: #4F6271;

  }

  .section-3 {
    background: #F5F7FA;
    /* 柔和背景灰 */
    color: #fff;

  }

  .section-4 {
    background: #F5F7FA;
    /* 柔和背景灰 */
    color: #fff;
  }

  .section-5 {
    margin-top: 50px;
    ;
    background: #A4B3C4;
    /* 灰藍 */
    color: #fff;
    height: 200px;
  }

  /* 主標題 - 更清楚 */
  h1 {
    font-size: 2.2rem;
    font-weight: 600;
    margin-bottom: 10px;
    color: #334A5F;
    /* 深藍灰，比原本更顯眼 */
  }

  /* 副標題 - 提高對比 */
  p {
    font-size: 1.1rem;
    opacity: 0.9;
    color: #2d3841;
    /* 提高對比，讓文字更清楚 */
  }
  .foot{
    color: #2d3841;
  }
  .foot-isMobile{
    font-size: 0.8rem ! important;
    color: #2d3841;
  }




  .carousel-img-review {
    width: 100%;
    /* 設定最大寬度 */   
    border: 1px solid #ddd;
    background-color: #f5f5f5;
    /* 背景讓圖片沒填滿時不會空白 */
  }

  .carousel-img-analysis {
    width: 100%;
    /* 設定最大寬度 */    
    object-fit: contain;
    /* 保持原始比例，縮小而不裁切 */
    border: 1px solid #ddd;
    background-color: #f5f5f5;
    /* 背景讓圖片沒填滿時不會空白 */
  }
  .carousel-img-isPC {
    height: 500px;
  }
  .carousel-img-isMobile {
    height: 150px ;
  }
  .carousel-img-isPC-review {
    object-fit: cover;
    height: 500px;
  }
  .carousel-img-isMobile-review {
    object-fit: contain;
    height: 150px ;
  }



  /* ============================================================= */
 /* 進出動畫 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* 懸浮選單容器 */
.floating-menu-container {
  position: fixed;
  right: 20px;
  /* top: 170px; */
  z-index: 1000;  
  flex-direction: column;
  align-items: flex-end;
  padding: 10px 10px 20px 10px
}
.floating-menu-container-mobile { 
  display: flex; 
  top: 301px !important;
  right: 0px !important;
  width: 4.5rem;
  left: 0px !important;
  margin-left: 83%;
}

/* 收合/展開按鈕 */
.menu-toggle {  
  margin-left: 125px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
/* .menu-toggle-mobile {
  float: inline-end;  
} */

/* 懸浮選單 */
.floating-menu {
  position: absolute;
  /* right: 0; */
  top: 60px;
  width: 180px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 12px;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
}
.floating-menu-mobile { 
  width: 120px;  
  padding: 1px;
 
}

/* 選單列表 */
.menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-list li {
  padding: 10px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  transition: 0.3s;
}
.menu-list a {
  color: white;  
  font-size: 16px;
}

/* 回到頂部按鈕 */
.top-button {
  text-align: center;
  margin-top: 10px;
}

.top-button .el-button {
  background: white;
  color: black;
  font-weight: bold;
  border-radius: 50%;
  width: 40px;
  height: 40px;
}
/* 歷屆活動表格css=======================================================*/
.custom-table {
  border-radius: 12px; /* 圓角 */
  overflow: hidden; /* 避免子元素溢出 */
  border: 2px solid var(--border-color); /* 動態框線顏色 */
}

.gray-theme {
  --border-color: #999;
  --header-bg: #ddd;
  --header-text: #333;
  --row-even-bg: #f5f5f5;
  --row-odd-bg: #e0e0e0;
}

</style>
